import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { searchEvents } from "../api/admin";

interface Row {
  id: number; ts: string; account_id: string | null; device_id: string | null;
  event_type: string; ip: string | null; detail: Record<string, unknown> | null;
}

export function EventsPage() {
  const { api } = useAuth();
  const [type, setType] = useState("");
  const [accountId, setAccountId] = useState("");
  const [rows, setRows] = useState<Row[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    searchEvents(api, { type: type || undefined, account_id: accountId || undefined, limit: 200 })
      .then((r) => { if (!cancelled) setRows(r.events); })
      .catch((e) => { if (!cancelled) setError(e.message); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [api, type, accountId]);

  return (
    <div className="vstack">
      <div>
        <h1>Auth events</h1>
        <p className="meta">Global event search. Use filters to narrow.</p>
      </div>
      <div className="hstack" style={{ gap: 16 }}>
        <div className="field" style={{ flex: 1, marginBottom: 0 }}>
          <label htmlFor="t">Event type</label>
          <input id="t" type="text" placeholder="e.g. login_fail" value={type}
            onChange={(e) => setType(e.target.value)} />
        </div>
        <div className="field" style={{ flex: 1, marginBottom: 0 }}>
          <label htmlFor="a">Account ID</label>
          <input id="a" type="text" placeholder="acc_…" value={accountId}
            onChange={(e) => setAccountId(e.target.value)} />
        </div>
      </div>
      {error && <div className="error">{error}</div>}
      <div className="card">
        {loading && <p className="meta">Loading…</p>}
        {!loading && rows.length === 0 && <p className="meta">No events.</p>}
        {rows.map((r) => (
          <div className="row" key={r.id}>
            <div>
              <div className="row-title">{r.event_type}</div>
              <div className="row-meta">
                {r.ts}
                {r.account_id ? (
                  <> · <Link to={`/accounts/${r.account_id}`}>{r.account_id.slice(0, 16)}…</Link></>
                ) : ""}
                {r.ip ? ` · ${r.ip}` : ""}
              </div>
              {r.detail && Object.keys(r.detail).length > 0 && (
                <div className="row-meta subtle">{JSON.stringify(r.detail)}</div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
